import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from '../../../locale/useTranslation';
import { useLocation, useNavigate } from 'react-router-dom';
import { ContentArrayImageCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ContentArrayImageCell';
import { ArrayCellFieldName } from '../../../framework/forms/helpercomponents/CustomGridCells/ArrayCellFieldName';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';
import { getSelectedState, Grid, GridColumn } from '@progress/kendo-react-grid';
import RefreshButton from '../../../framework/forms/helpercomponents/buttons/RefreshButton';
import BackRoundButton from '../../../framework/forms/helpercomponents/buttons/BackRoundButton';
import * as API_DIGI_SIGN from "../../../framework/API/api_digitalSign";
import * as API from "../../../framework/API/api";
import { PLAYLIST_SCHEDULE_TYPE, PLAYLIST_STATUS, TOAST_TYPES } from '../../../framework/constant/constant';
import { getter } from '@progress/kendo-data-query';
import MyStatusCell from '../../../components/MyStatusCell';
import { utility } from '../../../framework/utility/utilityProvider';
import { MenuCommandCell } from '../../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ';
import { collectionPlaylistScheduleMenuModel } from '../../../framework/forms/helpercomponents/contextMenu/menus/collectionMenuModel';
import SchedulePlaylistPopup from '../Playlist/SchedulePlaylistPopup';
import AddRoundButton from '../../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { DateTimeCell } from '../../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import { DigitalSignMobileSchedulePlaylistCollection } from '../mobileView/DigitalSignMobileSchedulePlaylistCollection';
import ToastNotification from "../../../components/ToastNotification";

const DigitalSignSchedulePlaylistCollection = (props) => {

    const SELECTED_FIELD = "selected";
    const DATA_ITEM_KEY = "_id";
    const idGetter = getter(DATA_ITEM_KEY);

    const lang = useTranslation();
    const navigate = useNavigate();
    let wherestatement = props.wherestatement ?? [];
    let page_take = props.page_take ?? 50;
    let sort = props.sort ?? { SID: 1 };
    let gridRowRender = props.gridRowRender;
    let filterable = props.filterable ?? false;
    let isPageable = props.isPageable ?? true;
    let enableMutliSelect = props.enableMutliSelect ?? false;

    const location = useLocation();
    const [showSchedulePopup, setShowSchedulePopup] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [dataColumns, setDataColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchText, setSearchText] = useState('');
    const initialSort = { field: Object.keys(sort)[0], dir: sort[Object.keys(sort)[0]] == 1 ? "asc" : "desc" }
    const [gridSort, setGridSort] = useState([initialSort]);
    const [isNoRecords, setIsNoRecords] = useState(false);
    const urlParams = new URLSearchParams(location?.search ?? "");
    const companyId = urlParams?.get('companyId');
    const [selectedState, setSelectedState] = useState({});
    const [scheduleTypeByDefault, setScheduleTypeByDefault] = useState(PLAYLIST_SCHEDULE_TYPE.SetDateRange);
    const [total, setTotal] = useState(1);
    const [page, setPage] = useState({
        skip: 0,
        take: page_take,
    });
    const selectedItemsRefs = useRef([]);
    const setSelectedItems = (items) => {
        selectedItemsRefs.current = items;
    }

    const schedulePlaylistItemRef = useRef([]);
    const setSchedulePlaylistItemRef = (item) => {
        schedulePlaylistItemRef.current = item;
    }

    let href = location.state ? location.state.href : false;
    if (href) {
        wherestatement = location.state.wherestatement;
    }

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const updateScreenType = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            setIsMobile(isPortrait); // Set true for portrait mode
        };
        updateScreenType();
        window.addEventListener('resize', updateScreenType);
        return () => window.removeEventListener('resize', updateScreenType);
    }, []);

    useEffect(() => {
        setIsLoading(true);
        setPage({ skip: 0, take: page_take });
        loaddata({ per_page: page_take, current_page: 1 }, wherestatement, searchText);
    }, []);

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim();
        setSearchText(text);
    };

    // Search 
    useEffect(() => {
        let sortEvent = gridSort[0] ?? initialSort;

        let newWhereStatement = [...wherestatement];

        if (searchText != "") {
            const timeOut = setTimeout(() => {
                setIsLoading(true);
                loaddata({ per_page: page.take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, newWhereStatement, searchText);
            }, 700);
            return () => clearTimeout(timeOut);
        } else {
            setIsLoading(true);
            setPage({ skip: 0, take: page_take });
            loaddata({ per_page: page_take, current_page: 1, orderby: sortEvent.field, direction: sortEvent.dir }, newWhereStatement, searchText);
        }
    }, [searchText]);

    const loaddata = async (pagination, wherestatement, searchText) => {
        setIsLoading(true);
        let todayDate = new Date().getTime();
        let finalSort = pagination?.direction ? { [pagination.orderby ?? 'SID']: pagination.direction == 'asc' ? 1 : -1 } : { SID: 1 };
        let newWhereStatement = [...wherestatement, ["Status", "in", [PLAYLIST_STATUS.Published, PLAYLIST_STATUS.UnPublished]], ["Schedule.StartDate", ">", todayDate], ["Schedule.EndDate", ">=", todayDate]];
        console.log(newWhereStatement);

        let res = await API_DIGI_SIGN.getPlaylists(
            { query: newWhereStatement, page: pagination.current_page, perPage: pagination.per_page, archive: false, sort: finalSort },
            searchText,
            companyId ? [companyId] : []
        );
        console.log(res);
        if (res.success) {
            console.log(res.data);
            setGridData(res.data);
            setTotal(res?.pagination?.total);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            setIsNoRecords(true);
            setGridData([]);
        }
        setIsLoading(false)
    };

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        let sortEvent = gridSort[0] ?? initialSort;
        await loaddata({ per_page: e.page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, searchText);
        setPage(e.page);
        cancelSelectedItem()
    };

    const refreshCollection = () => {
        setGridSort([initialSort]);
        loaddata({ per_page: page_take, current_page: 1 }, wherestatement, '');
    }

    const onSortChange = (e) => {
        setGridSort(e.sort)
        let sortEvent = e.sort[0] ?? sort;
        let current_page = page.skip / page.take + 1;
        loaddata({ per_page: page.take, current_page: current_page, orderby: sortEvent.field, direction: sortEvent.dir }, wherestatement, searchText);
    }

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);

        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];

        selectedIds.map((value) => {
            if (newSelectedState[value]) {
                let filter = gridData.find((obj) => obj._id == value);
                tempSelected.push(filter);
            }
        });

        setSelectedItems(tempSelected);
    };

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);

        var selectedIds = Object.keys(newSelectedState);
        var tempSelected = [];

        if (checked) {
            selectedIds.map((value) => {
                if (newSelectedState[value]) {
                    var filtered = gridData.find((obj) => obj._id == value);
                    tempSelected.push(filtered);
                }
            });
        }
        setSelectedItems(tempSelected);
    };

    const cancelSelectedItem = () => {
        setSelectedItems([]);
        setSelectedState({});
    }

    let timeOut;
    const handleColumnResize = (event) => {
        let lockedCol = event.columns.filter((item) => item?.locked).length ?? 1;
        try {
            if (event.index == 0) return;
            if (dataColumns == undefined || dataColumns.length == 0 || dataColumns.length < event.index) return;
            let column = dataColumns[event.index - lockedCol];
            let payload = {
                entityName: column?.entityName,
                name: column?.name,
                width: event.newWidth
            };
            clearTimeout(timeOut);
            timeOut = setTimeout(() => {
                API.updateUserPreferenceColumnWidth(payload);
            }, 700);
        } catch (error) {
            console.error("Error handling column resize:", error);
        }
    };

    const enterEdit = (item) => {
        console.log("onEnterEdit");
        setSchedulePlaylistItemRef(item);
        setShowSchedulePopup(true);
    };

    const createPlaylistCopy = async (playlistId) => {
        let playlistRes = await API_DIGI_SIGN.createDuplicatePlaylist(playlistId);
        if (!playlistRes.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Error creating Duplicate Playlist. Try again' });
            return;
        }
        navigate(`/home/PlaylistItem/${playlistRes.data}`);
    }

    const handleDelete = async (dataItem) => {
        console.log(dataItem);
        onPlaylistDelete(dataItem);
    };

    const onPlaylistDelete = async (dataItem) => {
        let res = await API_DIGI_SIGN.deletePlaylist(dataItem._id);
        if (res.success) {
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Playlist deleted successfully' });
            refreshCollection();
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }


    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            enterEdit={enterEdit}
            onDelete={handleDelete}
            myMenuModel={collectionPlaylistScheduleMenuModel}
        />
    );

    const MyPlaylistStatuscell = (props) => {
        const { dataItem } = props;
        const today = new Date().getTime();
        const startDate = dataItem?.Schedule?.StartDate ? new Date(dataItem.Schedule.StartDate).getTime() : null;
        const endDate = dataItem?.Schedule?.EndDate ? new Date(dataItem.Schedule.EndDate).getTime() : null;

        let status = "Upcoming";
        let tileBackColor = "#0000FF";

        if (startDate !== null && endDate !== null) {
            if (today >= startDate && today <= endDate) {
                status = "Running";
                tileBackColor = "#008000";
            } else if (today > endDate) {
                return null;
            }
        }
        return (<div> <MyStatusCell style={{ width: '100px', position: "relative", top: "3px" }} title={utility.convertCamelCaseToWords(status)} tileBackColor={tileBackColor} /></div>);
    };


    return (
        <>
            {isMobile ? <DigitalSignMobileSchedulePlaylistCollection handleDelete={handleDelete} onEnterEdit={enterEdit} isLoading={isLoading} gridData={gridData} 
            onAdd={() => { setScheduleTypeByDefault(PLAYLIST_SCHEDULE_TYPE.SetDateRange); setShowSchedulePopup(true);}} refreshCollection={refreshCollection}/> :
                <div>
                    <h1 className="page-title txt-color-bludeDark">
                        <i
                            className="fa fa-table marlr"
                            style={{ fontSize: "20px", color: "GrayText" }}
                        ></i>
                        <span>{lang.scheduled_playlist_header}</span>
                    </h1>
                    <div className="flex-container">
                        <div className="martb mar">
                            <BackRoundButton onClick={() => navigate(-1)}></BackRoundButton>
                            <AddRoundButton onClick={() => {
                                setScheduleTypeByDefault(PLAYLIST_SCHEDULE_TYPE.SetDateRange);
                                setShowSchedulePopup(true);
                            }} />
                        </div>
                        <div className="flex-container-reverse flex-item-auto">
                            <div className="input-group input-group w-300 martb" >
                                <input
                                    type="text"
                                    className="form-control shadow-inset-2 pt-0 pb-0"
                                    id="searchInput"
                                    placeholder={lang.search_button_text}
                                    onChange={onSearch}
                                    onFocus={(e) => {
                                        if (props.setOutSideFocus) {
                                            props.setOutSideFocus(true);
                                        }
                                    }}
                                    onBlur={(e) => {
                                        if (props.setOutSideFocus) {
                                            props.setOutSideFocus(false);
                                        }
                                    }}
                                />
                                <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                                    <div className="input-group-append">
                                        <span className="input-group-text">
                                            <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                        </span>
                                    </div>
                                </button>
                            </div>
                            <div className="mt-1" style={{ paddingTop: "12px" }}>
                                <RefreshButton
                                    onClick={refreshCollection}
                                />
                            </div>
                        </div>
                    </div>
                    {isLoading && <Loader />}
                    {isNoRecords && <div style={{ margin: "0px 500px" }}><h4><strong>{lang.no_records_found}</strong></h4></div>}
                    {!isLoading && !isNoRecords &&
                        <Grid
                            style={props.gridstyle ?? {
                                height: "76vh",
                            }}
                            sort={gridSort}
                            onSortChange={onSortChange}
                            rowRender={gridRowRender}
                            filterable={filterable}
                            pageable={isPageable}
                            skip={page.skip}
                            take={page.take}
                            onPageChange={pageChange}
                            total={total}
                            resizable={true}
                            onColumnResize={handleColumnResize}
                            data={
                                gridData.map((item) => ({
                                    ...item,
                                    [SELECTED_FIELD]: selectedState[idGetter(item)],
                                }))}
                            selectedField={SELECTED_FIELD}
                            selectable={{
                                enabled: enableMutliSelect,
                                drag: false,
                                cell: false,
                                mode: "multiple",
                            }}
                            dataItemKey={DATA_ITEM_KEY}
                            onSelectionChange={onSelectionChange}
                            onHeaderSelectionChange={onHeaderSelectionChange}
                        >
                            {/* Edit Row */}
                            <GridColumn cell={MyCommandCell} width={"60px"} locked={true} resizable={false} />
                            <GridColumn field="Name" title="Playlist Name" />
                            <GridColumn field="Status" title="Status" cell={MyPlaylistStatuscell} />
                            <GridColumn field="Schedule.StartDate" title="Start Date" cell={DateTimeCell} />
                            <GridColumn field="Schedule.EndDate" title="End Date" cell={DateTimeCell} />
                            <GridColumn field="screenGroup" title="Screen Group" cell={ArrayCellFieldName} />
                            <GridColumn field="playlistItem" title="Playlist Items" cell={ContentArrayImageCell} />
                        </Grid>}
                </div>
            }
            {showSchedulePopup && <SchedulePlaylistPopup playlistItem={schedulePlaylistItemRef.current} isMainForm={true} scheduleTypeByDefault={scheduleTypeByDefault} close={() => setShowSchedulePopup(false)} refresh={refreshCollection} />}

        </>
    );
}

export default DigitalSignSchedulePlaylistCollection